import "../elements/floating-button";
import "../elements/file-picker";
import "../elements/nav-tree";
import "../elements/readspeaker-button";
import "../elements/validation-form";
import "../elements/vimeo-wrapper";
import "../elements/youtube-wrapper";
import "../elements/password-formcontrol";

// HTML has loaded
document.addEventListener("DOMContentLoaded", () => {

    // Add code here

}, false);

// Images, etc has loaded
window.addEventListener("load", () => {

    // Add code here

});